module.exports = __webpack_public_path__ + "3518605fe22cfc1484ff53dd5d0373dd.png";